<template>
  <l-layout :layout="['xs12']">
    <l-data-table
      :get-data-func="getPartners"
      :headers="headers"
      :must-sort="false"
      @click:row="goDetails($event.item)"
      clickable
      :filter-items="filterItems"
      item-key="code"
      ref="list"
      search-text="搜索姓名"
      selectable
      title-text="合作用户列表"
      v-model="selected"
    >
      <template slot="title-action">
        <l-option-menu
          :options="moreActions"
          @delete="deletePartners(selected)"
        >
          <v-btn icon slot="activator">
            <v-icon>$vuetify.icons.more</v-icon>
          </v-btn>
        </l-option-menu>
      </template>
      <template slot="row-action" slot-scope="{item}">
        <td @click.stop>
          <v-menu  left>
            <v-btn slot="activator" icon small>
              <v-icon  small>$vuetify.icons.more</v-icon>
            </v-btn>
            <v-list dense>
              <v-list-tile @click="deletePartner(item)">
                <v-list-tile-title class="pr-1">
                  删除合作用户
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="editPartner(item)">
                <v-list-tile-title class="pr-1">
                  编辑合作用户
                </v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </td>
      </template>
    </l-data-table>
    <v-container class="pt-3 px-0" fluid grid-list-lg>
      <v-layout>
       <!-- <v-flex sm4 xs6>
          <l-action-card @click="goExport" icon="$vuetify.icons.group" label="批量导入合作用户"></l-action-card>
        </v-flex>-->
        <v-flex sm4 xs6>
          <l-action-card @click="goNew" icon="$vuetify.icons.person" label="单独添加合作用户"></l-action-card>
        </v-flex>
      </v-layout>
    </v-container>
    <l-select-file
      v-model="exportActivate"
      dialog-title-text="批量导入合作用户"
      select-type="dialog"
      :hint="'仅支持Excel(.xlsx)文件'"
      :rules="exportRules"
      @cancel="exportActivate = false"
      @submit="readExcel"
      file-type="excel"
    >
      <!--<template slot="before-drag">-->
      <!--<v-layout align-center class="mb-3 pl-2" row>-->
      <!--<span class="body-2">批量添加合作用户需要上传特定格式的模板</span>-->
      <!--<v-btn-->
      <!--:href="templateHref"-->
      <!--@click="getVehicleFileTemplate"-->
      <!--color="primary"-->
      <!--flat-->
      <!--ref="templateBtn"-->
      <!--small-->
      <!--target="_blank"-->
      <!--&gt;点此下载-->
      <!--</v-btn>-->
      <!--</v-layout>-->
      <!--</template>-->
    </l-select-file>
    <v-dialog max-width="1000px" persistent scrollable v-model="importDialog.activate">
      <v-card>
        <v-card-title style="height: 64px;">
          <span class="title">批量导入合作用户</span>
        </v-card-title>
        <v-card-text style="min-height: 350px; max-height: 500px">
          <div class="mb-4" v-if="importDialog.fails.length > 0">
            <div class="subheading py-2">以下用户信息格式错误</div>
            <!--<v-divider></v-divider>-->
            <l-data-table
              :must-sort="false"
              :headers="partnerHeaders"
              :init-pagination="{rowsPerPage: 5 , descending: false}"
              :items="importDialog.fails"
              auto-actions
              flat
              hide-title
            ></l-data-table>
          </div>
          <div class="mb-4" v-if="importDialog.duplicates.length > 0">
            <div class="subheading py-2">以下用户已在列表中</div>
            <!--<v-divider></v-divider>-->
            <l-data-table
              :must-sort="false"
              :headers="partnerHeaders"
              :init-pagination="{rowsPerPage: 5 , descending: false}"
              :items="importDialog.duplicates"
              auto-actions
              flat
              hide-title
            ></l-data-table>
          </div>
          <div v-if="importDialog.corrects.length > 0">
            <div class="py-2">
              <div class="subheading">以下用户信息正确，等待导入</div>
              <div class="py-1" v-if="importDialog.haveDuplicatePlate">
                <span class="error--text caption">您导入的模板中含有重复的用户，导入时将以重复数据的第一条为准</span>
              </div>
            </div>
            <!--<v-divider></v-divider>-->
            <l-data-table
              :must-sort="false"
              :headers="partnerHeaders"
              :init-pagination="{rowsPerPage: 5 , descending: false}"
              :items="importDialog.corrects"
              auto-actions
              flat
              hide-title
            ></l-data-table>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="importItems(0)" color="grey" flat large>取消导入</v-btn>
          <v-btn :disabled="importDialog.corrects.length === 0"
                 @click="importItems(importDialog.corrects)"
                 :loading="importDialog.loading"
                 color="primary" flat large>导入用户
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </l-layout>
</template>
<script>
import LActionCard from '../../../../../components/LActionCard'

export default {
  name: 'PartnerList',
  components: {LActionCard},
  props: ['refresh'],
  data () {
    return {
      importDialog: {
        activate: false,
        corrects: [],
        fails: [],
        duplicates: [],
        haveDuplicatePlate: false,
        loading: false,
      },
      templateHref: '',
      exportActivate: false,
      exportRules: [
        v => !(!v || v.length === 0) || '必选',
        v => !v.some(f => !/\.xlsx$/i.test(f.name)) || '仅支持Excel表格(.xlsx)格式',
      ],
      selected: [],
      moreActions: [
        {
          event: 'delete',
          label: '批量删除',
          icon: '$vuetify.icons.deleteAll',
        },
      ],
      partnerHeaders: [
        {text: '姓名', value: 'name', align: 'left', placeholder: 'N/A'},
        {text: '账号', value: 'code', align: 'right', placeholder: 'N/A'},
        {text: '手机', value: 'phone', align: 'right', placeholder: 'N/A'},
        {text: '单位', value: 'orgName', align: 'right', placeholder: 'N/A'},
        {text: '车辆号牌', value: 'vehicleList', align: 'right', placeholder: 'N/A'},
      ],
      headers: [
        {text: '姓名', value: 'name', align: 'left', placeholder: 'N/A', sortable: false},
        {text: '账号', value: 'code', align: 'right', placeholder: 'N/A', sortable: false},
        {text: '单位', value: 'orgName', align: 'right', placeholder: 'N/A', sortable: false},
        {text: '状态', value: 'statusName', align: 'right', placeholder: 'N/A', sortable: false},
        {
          text: '更新时间',
          value: 'updateTime',
          align: 'right',
          placeholder: 'N/A',
          sortable: false,
          f: v => this.$L.time.stringify(v),
        },
        {text: '', value: '', align: 'center', width: '80px', sortable: false},
      ],
      filterItems:[
        {
          prependIcon: '$vuetify.icons.person',
          key: 'loginId',
          value: '',
          label: '账号',
          type: 'input',
          layout: ['xs12', 'sm4'],
        },
      ],
    }
  },
  methods: {
    async importItems (items) {
      if (items instanceof Array) {
        console.log(';import', items)
        this.$set(this.importDialog, 'loading', true)
        try {
          await this.$store.dispatch('mva/setPartners', items)
          this.$L.alert('success', '提交成功')
        }
        catch (e) {
          this.$L.alert('error', e.message)
        }
        finally {
          this.$set(this.importDialog, 'loading', false)
        }
      }
      this.importDialog = {
        activate: false,
        corrects: [],
        fails: [],
        duplicates: [],
        haveDuplicatePlate: false,
      }
    },
    async readExcel (files) {
      let XLSX = await import('xlsx')
      let f = files[0]
      if (!(f instanceof File)) return
      let reader = new FileReader()
      reader.onload = (event) => {
        try {
          let data = event.target.result
          let workbook = XLSX.read(data, {type: 'array'})
          let keys = Object.keys(workbook.Sheets)
          if (Object.keys(workbook.Sheets).length < 1) {
            throw Error('模板格式错误')
          }
          let sheet = workbook.Sheets[keys[0]]
          let ref = sheet['!ref']
          let group = /^[A-Z]+(\d+):[A-Z]+(\d+)$/.exec(ref)
          if (!group) {
            throw Error('模板格式错误')
          }
          let s = Number(group[1])
          let e = Number(group[2])

          let atters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H']
          let items = []
          let fails = []
          let duplicates = []
          let haveDuplicatePlate = false

          let getVal = cell => {
            return cell ? cell.w.trim() : ''
          }

          for (let i = s + 1; i <= e; ++i) {
            let name = getVal(sheet[atters[0] + i])
            let code = getVal(sheet[atters[1] + i])
            let phone = getVal(sheet[atters[2] + i])
            let orgCode = getVal(sheet[atters[3] + i])
            let orgName = getVal(sheet[atters[4] + i])
            let vehicles = getVal(sheet[atters[5] + i])
            let statusName = getVal(sheet[atters[6] + i])
            let statusCode = getVal(sheet[atters[7] + i])
            // Fixme: 需要检测去除所有左右空格（空白，换行，制表等）

            let v = {
              'code': code,
              'name': name,
              'orgCode': orgCode,
              'orgName': orgName,
              'phone': phone,
              'contractEndTime': '',
              'vehicleList': vehicles,
              'statusCode': statusCode,
              'statusName': statusName,
              'deleteFlag': '',
              'updateTime': '',
            }
            items.push(v)
          }

          this.importDialog = {
            activate: true,
            corrects: items,
            fails: fails,
            duplicates: duplicates,
            haveDuplicatePlate: haveDuplicatePlate,
          }
        }
        catch (e) {
          this.$L.alert({title: '读取导入模板时发生错误', message: '给定的文件格式错误，或浏览器版本不支持'})
        }
      }
      reader.readAsArrayBuffer(f)
    },
    async deletePartner (item) {
      let {res, close} = await this.$L.confirm({
        title: '确认删除',
        text: `确认删除合作用户 ${item.name} ?`,
      })
      if (res) {
        try {
          await this.$store.dispatch('mva/deletePartners', [item])
          this.$refs.list.refresh()
          this.$L.alert('success', '删除成功')
        }
        catch (e) {
          this.$L.alert('error', e.message)
        }
      }
      close()
    },
    editPartner (item) {
      this.$router.replace({
        name: 'EditPartner',
        params: {name: item.name},
        query: {code: item.code}
      })
    },
    async deletePartners (items) {
      if (items instanceof Array && items.length) {
        let {res, close} = await this.$L.confirm({
          title: '确认删除',
          text: `确认删除 ${items.length} 位合作用户 ?`,
          subText: items.map(t => t.name),
        })
        if (res) {
          try {
            await this.$store.dispatch('mva/deletePartners', items)
            this.$refs.list.refresh()
            this.$L.alert('success', '删除成功')
            this.selected = []
          }
          catch (e) {
            this.$L.alert('error', e.message)
          }
        }
        close()
      }
    },
    async getPartners ({pagination, search,filterItems}) {
      return this.$store.dispatch('mva/getPartners', {
        pagination,
        search: {name: {keyword: search}},
        filterItems
      })
    },
    goDetails (item, force = false) {
      let selectionString = document.getSelection().toString()
      if (!selectionString || force) {
        this.$router.push({
          name: 'PartnerDetails',
          params: {name: item.name},
          query: {code: item.code},
        })
      }
    },
    goNew () {
      this.$router.push({
        name: 'NewPartner',
      })
    },
    goExport () {
      this.exportActivate = true
    },
  },
  activated () {
    if (this.refresh) {
      this.$refs.list.refresh()
    }
  },
}
</script>

<style scoped>

</style>
